import { useEffect, useState } from "react";
import { useWindowSize } from "react-use";
import { useTransform, useViewportScroll } from "framer-motion";

const useTestDriveMapHeightCalculator = (shouldUpdate = true) => {
  const { height } = useWindowSize();
  const { scrollY } = useViewportScroll();

  const [viewportHeight, setViewportHeight] = useState(null);

  // first array represents range of header in pixels
  // second array represents calculation of distance
  const calculatedMapHeight = useTransform(
    scrollY,
    [0, 79],
    [viewportHeight - 79, viewportHeight]
  );

  useEffect(() => {
    if (shouldUpdate) {
      setViewportHeight(window.innerHeight);
    }
  }, [height, shouldUpdate]);

  return {
    calculatedMapHeight,
  };
};

export default useTestDriveMapHeightCalculator;
